export default class GeneratePcrdRequestNotFoundError extends Error {}
